<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <!-- {{ animateursDeProjets }} -->

        <v-card flat v-if="user.role === 'operateur'">
          <v-card-text>
            <vue-excel-xlsx
              :data="animateurs"
              :columns="columnAnimateurs"
              :filename="'animateurs'"
              :sheetname="'animateurs'"
            >
              <v-btn class="primary">
                <v-icon>mdi-microsoft-excel</v-icon> Télécharger</v-btn
              >
            </vue-excel-xlsx>

            <v-card flat>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="elevation-0"
                :headers="headers"
                :items="animateurs"
                :search="search"
              >
                <template v-slot:item.projets="{ item }">
                  <ul>
                    <li
                      v-for="(projets, indexprojets) in item.projets"
                      :key="indexprojets"
                    >
                      {{ projets.ll_programme }}
                    </li>
                  </ul>
                </template>
                <template v-slot:item.dateLastConnexion="{ item }">
                  <span
                    v-if="item.dateLastConnexion"
                    v-html="
                      $moment(item.dateLastConnexion).format(
                        'DD-MM-YYYY HH:mm:ss'
                      )
                    "
                  ></span>
                </template>
                <template v-slot:item.districts="{ item }">
                  <ul>
                    <li
                      v-for="(dsitrict, indexdistrict) in item.districts"
                      :key="indexdistrict"
                    >
                      {{ dsitrict.ll_district }}
                    </li>
                  </ul>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    outlined
                    x-small
                    fab
                    dark
                    class="success"
                    @click="detailsUser(item)"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-card>
        <v-card flat v-else>
          <v-card-text>
            <vue-excel-xlsx
              :data="animateursDeProjets"
              :columns="columnAnimateurs"
              :filename="'animateurs'"
              :sheetname="'animateurs'"
            >
              <v-btn class="primary">
                <v-icon>mdi-microsoft-excel</v-icon> Télécharger</v-btn
              >
            </vue-excel-xlsx>

            <v-card flat>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="elevation-0"
                :headers="headers"
                :items="animateursDeProjets"
                :search="search"
              >
                <template v-slot:item.projets="{ item }">
                  <ul>
                    <li
                      v-for="(projets, indexprojets) in item.projets"
                      :key="indexprojets"
                    >
                      {{ projets.ll_programme }}
                    </li>
                  </ul>
                </template>
                <template v-slot:item.dateLastConnexion="{ item }">
                  <span
                    v-if="item.dateLastConnexion"
                    v-html="
                      $moment(item.dateLastConnexion).format(
                        'DD-MM-YYYY HH:mm:ss'
                      )
                    "
                  ></span>
                </template>
                <template v-slot:item.districts="{ item }">
                  <ul>
                    <li
                      v-for="(dsitrict, indexdistrict) in item.districts"
                      :key="indexdistrict"
                    >
                      {{ dsitrict.ll_district }}
                    </li>
                  </ul>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    outlined
                    x-small
                    fab
                    dark
                    class="success"
                    @click="detailsUser(item)"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.SetProjectList();
    this.getAnimateurs(this.regionSupervisees);
  },
  data() {
    return {
      ProjetctList: [],
      search: "",
      headers: [
        {
          text: "Nom",
          value: "displayName",
        },
        { text: "Projets", value: "projets" },
        { text: "Date de dernière connexion", value: "dateLastConnexion" },
        { text: "Districts", value: "districts" },
        { text: "Actions", value: "actions" },
      ],
      columnAnimateurs: [
        {
          label: "Nom",
          field: "displayName",
        },
        {
          label: "Projets",
          field: "animateur.projets",
        },
        {
          label: "Districts",
          field: "animateur.districts",
        },
      ],
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    detailsUser(item) {
      console.log(item);
      this.$router.push({
        name: "Users-id",
        params: { item },
      });
    },
    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },

    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getAnimateurs: "Users/getAnimateurs",
      //getAnimateursDeProjets: "Users/getAnimateursDeProjets",
    }),
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      Auth: (state) => state.Auth,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      animateurs: (state) => state.Users.animateursDeRegions,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
      projets: (state) => state.Auth.user.projets,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
